import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { LoggerService } from '@app/core/logger/logger.service';
import { AnalyticsService } from '../analytics.service';

@Directive({
  selector: '[appSendAnalytics]'
})
export class SendAnalyticsDirective {
  @Input() checkLoggedIn = false;

  @HostListener('click') onClick() {
    this.sendAnalytics();
  }

  constructor(
    private el: ElementRef,
    private analyticsService: AnalyticsService,
    private loggerService: LoggerService
  ) {}

  /** Sending button id, aria.label and isLoggedIn(if needed) to GTM when the element is clicked. */
  private sendAnalytics(): void {
    const elementId = this.el.nativeElement.id;
    const ariaLabel = this.el.nativeElement.getAttribute('aria-label');
    const classList = this.el.nativeElement.classList;
    const tagName = this.el.nativeElement.tagName;

    if (!elementId || !ariaLabel) {
      this.loggerService.warn(
        `Element does not have id(${elementId}) or aria-label(${ariaLabel}): <${tagName}> ${classList}`
      );
    }

    this.analyticsService.onButtonClicked(elementId, ariaLabel);
  }
}
